import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const emailLogApiKeyStore = {
  generateEmailLogWithPagination: (): MutationKeyConfig => ({
    mutationKey: [`GENERATE_EMAIL_LOG`],
    route: `/Audit/EmailLogs`,
    action: 'POST',
    disableSnackbar: true,
  }),
  exportEmailExcel: (): MutationKeyConfig => ({
    mutationKey: [`EXPORT_EMAIL_EXCEL`],
    route: `/Export/EmailLog`,
    action: 'POST',
    disableSnackbar: true,
  }),
};
